import request from '@/utils/request'

// 数据中心查询列表
// export function dataAnalysePageList(data) {
//   return request({
//     url: '/health-doctor-assistant/doctor-assistant/data-analyse/page',
//     method: 'post',
//     data
//   })
// }
export function dataAnalysePageList(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/data-analyse/dataAnalyse/page',
    method: 'post',
    data
  })
}

// 数据完善度查询
export function listDataComplete(data) {
  return request({
    url: '/health-emr/doctor-assistant/listDataComplete',
    method: 'post',
    data
  })
}

// 有效工单数查询
export function pageEffectiveWork(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/data-analyse/pageEffectiveWork',
    method: 'post',
    data
  })
}

// 工单积分查询
export function pageWorkPoints(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/data-analyse/pageWorkPoints',
    method: 'post',
    data
  })
}

// 销售提成统计list
export function salesBonusList(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/bonus/page',
    method: 'post',
    data
  })
}
// 导出销售提成统计list
export function salesBonusExcel(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/bonus/excel',
    method: 'post',
    data
  })
}
// 销售提成统计——详情
export function salesBonusDetail(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/bonus/detail/page',
    method: 'post',
    data
  })
}
// 导出销售提成统计详情
export function salesBonusDetailExcel(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/bonus/detail/excel',
    method: 'post',
    data
  })
}
// 完成工单数查询
export function completeWorkOrderPageList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderStatistics/listCompleteWorkOrder',
    method: 'post',
    data
  })
}
// 满意数查询
export function satisfiedPageList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderStatistics/listSatisfiedCnt',
    method: 'post',
    data
  })
}
// 不满意数查询
export function dissatisfiedPageList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderStatistics/listDisSatisfiedCnt',
    method: 'post',
    data
  })
}
// 回滚超三次工单数查询
export function rollbackOverThreePageList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderStatistics/listMoreThreeRollback',
    method: 'post',
    data
  })
}
// 优秀案例数查询
export function excellentCasePageList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderStatistics/listExcellentCase',
    method: 'post',
    data
  })
}

// 效益金额查询
export function benifitsPageList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderStatistics/listBenefitAmountWorkOrder',
    method: 'post',
    data
  })
}
